import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Layout from "../../components/layout/Layout";
import {
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { Grid, Box, Select, MenuItem, Pagination } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import Admin from "../../components/auth/Admin";
import AddCustomerForm from "../../components/forms/addCustomer";
import Customer from "../../actions/customer";
import Popup from "../../components/customHelpers/Popup";
import produce from "immer";
import SaveCustomersFromFile from "../../components/SaveCutomerFromFile";
import ImportFile from "../../actions/ImportFile";
import { Image_API } from "../../config";
import InfoComponent from "../../components/InfoComponent";
import { useHistory } from "react-router-dom";
import { pageSizes } from "../../utils/utils";
import Permission from "../../components/auth/Permisstion";

const headCells = [
  { id: "fullName", label: "FullName" },
  { id: "email", label: "email" },
  { id: "phoneNo", label: "Phone" },
  { id: "location", label: "Location" },
  { id: "address", label: "Address" },
  { id: "contact", label: "Contact" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const CustomerPage = () => {
  const { data, colDefs, importExcel, setData } = ImportFile();
  const filePicker = useRef(null);
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllCustomersWithPages, deleteCustomer } = Customer();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const [openPopupBulkSave, setOpenPopupBulkSave] = useState(false);
  const [record, setRecord] = useState({
    data: [],
    colDefs: [],
  });
  const [customers, setCustomers] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllCustomers();
  }, [reload, page, limit, searchQuery]);

  if (data && data.length != 0) {
    setRecord({ data, colDefs });
    setData([]);
    setOpenPopupBulkSave(true);
  }

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllCustomers = () => {
    setValues({ ...values, loading: true });
    viewAllCustomersWithPages(page, limit, searchQuery).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.customers) {
        setValues({
          ...values,
          loading: false,
        });
        setCustomers(data.customers);
        setTotalPages(Math.ceil(data.total / limit));
        setTot(data.pagination.totalPages);
        setActualTotal(data.pagination.total);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setValues({ ...values, loading: true });
    deleteCustomer(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({ ...values, loading: false });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, loading: false });
        setCustomers(
          produce(customers, (draft) => {
            const index = customers.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const { TblContainer, TblHead, recordsAfterSortingAndFiltering } = useTable(
    customers,
    headCells,
    filterFn
  );

  const handleSearch = (e) => {
    setPage(1);
    setSearchQuery(e.target.value);
  };

  const handleDownload = () => {
    fetch(`${Image_API}/download/customer`)
      .then((response) => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error("Network response was not ok.");
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "customer.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        NotifyMessage({
          message: "There was a problem with your fetch operation:",
          type: "error",
        });
        console.error("There was a problem with your fetch operation:", error);
      });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);

  return (
    <Layout>
      <Permission permission="viewCustomer" />
      <Admin>
        <div className="card">
          <Box
            display="flex"
            alignItems="center"
            className="page-header-bar"
            justifyContent="space-between"
            mb={2}
          >
            <Typography
              variant="h6"
              className="page-header"
              style={{ margin: 0 }}
            >
              Customers
            </Typography>

            <div className="page-header-actions">
              <Grid container spacing={1} className="header-buttons-grid">
                <Grid item>
                  <Controls.Button
                    text="Add Customer"
                    variant="outlined"
                    startIcon={<IoMdAdd />}
                    className="newButton"
                    sx={{ padding: 2 }}
                    onClick={() => {
                      setOpenPopup(true);
                      setRecordForEdit(null);
                      setEdit(false);
                    }}
                  />
                </Grid>
                <Grid item>
                  <Controls.Button
                    color="primary"
                    onClick={() => {
                      filePicker.current.click();
                    }}
                    startIcon={<UploadFileIcon />}
                    variant="outlined"
                    text="Import file"
                    className="newButton"
                  />
                  <input
                    label="Icon"
                    name="image"
                    type="file"
                    hidden
                    ref={filePicker}
                    onChange={importExcel}
                    autoFocus={true}
                  />
                </Grid>
                <Grid item>
                  <Controls.Button
                    color="primary"
                    onClick={() => {
                      handleDownload();
                    }}
                    startIcon={<DownloadIcon />}
                    variant="outlined"
                    text="Download"
                    className="newButton"
                  />
                </Grid>
              </Grid>
            </div>
          </Box>
          <InfoComponent pageKey="customers" />

          <div
            className="search-header-container"
            style={{
              marginBottom: 0,
              marginTop: 10,
              flex: 1,
              maxWidth: 260,
              minWidth: 260,
            }}
          >
            <div className="search-header-flex">
              <div className="search-container">
                <Search className="search_icon" />
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search Customer"
                  className="search-input"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <Box sx={{ minWidth: "800px" }}>
                    <TblContainer className="page-table order-page-table">
                      <TblHead />
                      <TableBody>
                        {recordsAfterSortingAndFiltering().length > 0 ? (
                          recordsAfterSortingAndFiltering().map((item) => (
                            <TableRow key={item.id}>
                              <TableCell style={{ width: "14%" }}>
                                {item.fullName}
                              </TableCell>
                              <TableCell style={{ width: "15%" }}>
                                {item.email}
                              </TableCell>
                              <TableCell style={{ width: "14%" }}>
                                {item.phoneNo}
                              </TableCell>
                              <TableCell style={{ width: "10%" }}>
                                {item.location}
                              </TableCell>
                              <TableCell style={{ width: "10%" }}>
                                {item.address}
                              </TableCell>
                              <TableCell>{item.contact}</TableCell>
                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "5px",
                                    flexWrap: "nowrap",
                                  }}
                                >
                                  <Controls.ActionButton
                                    color="secondary"
                                    title="Delete"
                                    onClick={() => {
                                      setConfirmDialog({
                                        isOpen: true,
                                        title:
                                          "Are you sure to delete this Customer?",
                                        subTitle:
                                          "You can't undo this operation",
                                        onConfirm: () => {
                                          onDelete(item.id);
                                        },
                                      });
                                    }}
                                  >
                                    <MdOutlineDelete fontSize="medium" />
                                  </Controls.ActionButton>
                                  <Controls.ActionButton
                                    color="primary"
                                    title="Update"
                                    onClick={() => {
                                      setOpenPopup(true);
                                      setRecordForEdit(item);
                                      setEdit(true);
                                    }}
                                  >
                                    <FiEdit fontSize="medium" />
                                  </Controls.ActionButton>
                                  <Controls.ActionButton
                                    color="primary"
                                    title="View Detail"
                                    onClick={() => {
                                      history.push(
                                        `/customer/order/${item.id}`
                                      );
                                    }}
                                  >
                                    <FiEye fontSize="medium" />
                                  </Controls.ActionButton>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <Norecords col={6} />
                        )}
                      </TableBody>
                    </TblContainer>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      p: 2,
                      backgroundColor: "background.paper",
                      borderTop: 1,
                      borderColor: "divider",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {customers.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || customers.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={customers.length === 0}
                      />
                    )}
                  </Box>
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Customer Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddCustomerForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setCustomer={setCustomers}
            edite={edite}
          />
        </Popup>
        <Popup
          title="Import Customers"
          openPopup={openPopupBulkSave}
          setOpenPopup={setOpenPopupBulkSave}
          maxWidth={false}
        >
          <SaveCustomersFromFile
            file={record}
            NotifyMessage={NotifyMessage}
            setOpenPopupBulkSave={setOpenPopupBulkSave}
            getAllCustomers={getAllCustomers}
            customers={customers}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default CustomerPage;
